import NumericInput from 'components/inputs/NumericInput'
import { observer } from 'mobx-react'
import React from 'react'
import {
  FilterViewDivider,
  FilterViewHeader,
  FilterViewItem,
  FilterViewItemContainer,
} from '..'
import { NumberRangeFilter } from './NumberRangeFilter'

interface NumberRangeFilterViewProps<TFilters extends Record<string, unknown>> {
  filter: NumberRangeFilter<keyof TFilters>
  currencyCode: string
  unitName: string
}

export const NumberRangeFilterView = observer(function DateRangeFilterView<
  TFilters extends Record<string, unknown>,
>({ filter, currencyCode, unitName }: NumberRangeFilterViewProps<TFilters>) {
  return (
    <>
      <FilterViewHeader
        title={filter.title}
        onClear={() => {
          filter.clearValue()
          filter.stopEditing()
        }}
        dataTest={'job-number-range-filter-clear-button'}
      />
      <FilterViewItemContainer>
        <FilterViewItem title={`Min ${unitName}`}>
          <NumericInput
            currencyCode={currencyCode}
            precision={2}
            value={filter.value?.min}
            onChange={filter.setMin}
            dataTest={'job-number-range-filter-from-field'}
          />
        </FilterViewItem>
        <FilterViewDivider />
        <FilterViewItem title={`Max ${unitName}`}>
          <NumericInput
            currencyCode={currencyCode}
            precision={2}
            value={filter.value?.max}
            onChange={filter.setMax}
            dataTest={'job-number-range-filter-to-field'}
          />
        </FilterViewItem>
      </FilterViewItemContainer>
    </>
  )
})
